import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import GearClassService from "@services/GearClassService";

const ShowGearClass = ({ gearClass }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [gearClassData, setGearClassData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      GearClassService.find(gearClass.id).then((response) => {
        setGearClassData(response.data.data);
      });
  }, [gearClass.id, showModal]);

  return (
    <PermissionHandler permission={"view_gear_classes"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={gearClassData.name} />
          <RowDetails label={t("nameEng")} value={gearClassData.name_eng} />
          <RowDetails
            label={t("description")}
            value={gearClassData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowGearClass;
